import { makeGraphQLRequest } from '../../utils/requestUtils';

export default async function requestOrganizationById(orgId, userId) {
  const query = `query requestOrganizaionById(
    $orgId: ID, $userId: ID
  ) {
      organization(id: $orgId) {
        name
        cageCode
        iconStatus
        users {
          name
          email
          faxNumber
          phoneNumber
          role
          id
          iconStatus
        }
      }
      user(id: $userId) {
        
        organizationId 
        role
      }
    }`;

  const variables = { orgId, userId };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

// export async function updateUserMetaData(userId, orgId) {
//   const query =
//     'mutation updateUserMetaData($userId: ID, $orgId: ID) { updateUserMetaData(userId: $userId, orgId: $orgId) { name } }';
//   const variables = { userId, orgId };
//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response;
// }



// WEBPACK FOOTER //
// ./src/pages/InventoryManagement/graphql.js